var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9483 17.7374L26.3759 15.6053C26.3156 15.3616 26.0746 15.2399 25.8339 15.3007L23.6349 15.8794L21.2251 6.83325C21.1648 6.58955 20.9238 6.46781 20.683 6.52858L15.9539 7.80783L14.6588 2.96498C14.5985 2.72129 14.3575 2.59955 14.1167 2.66031L8.03224 4.27461L7.24914 1.32014C7.18884 1.07644 6.94784 0.9547 6.7371 1.01547L1.88759 2.2337C1.25494 2.41642 0.863522 3.05613 1.0442 3.69565C1.22489 4.33539 1.5 5.5 2.59035 5.09681L4.79941 4.54839L9.90994 23.4021C9.97024 23.6458 10.2112 23.7676 10.452 23.7068L12.0985 23.2501C12.7311 24.6206 14.2973 25.3821 15.8033 24.9557C17.3094 24.5597 18.2734 23.1281 18.1528 21.6051L25.924 19.5341C26.7073 19.3824 27.159 18.5294 26.9483 17.7374ZM22.8215 16.1231L12.008 19.0166L9.68863 10.3968L20.5021 7.50331L22.8215 16.1231ZM13.9358 3.60462L15.1105 8.02105L9.44772 9.54398L8.2732 5.12755L13.9358 3.60462ZM10.6328 22.763L5.51203 3.93968C5.45173 3.75696 5.27104 3.60462 5.09035 3.60462H5L2.36924 4.24436C1.73878 4.27461 1.5 3.5 2.0982 3.05631L6.52602 1.92939L11.2852 19.6562C11.3455 19.8999 11.5865 20.0217 11.8272 19.9609L12.6406 19.7476C11.9478 20.4787 11.6766 21.5142 11.8272 22.4584L10.6328 22.763ZM15.5624 24.164C14.3577 24.4991 13.1227 23.829 12.7613 22.6411C12.3696 21.3618 13.0926 20.052 14.3577 19.717C15.6831 19.3515 16.9782 20.2347 17.2192 21.4532C17.4902 22.7021 16.7069 23.829 15.5624 24.164ZM25.6832 18.7424L17.942 20.8135C17.6107 19.8997 16.8276 19.1688 15.8939 18.8945C18.8457 18.1027 22.6109 17.0975 25.6531 16.2751L26.1049 17.9807C26.1952 18.316 26.0145 18.651 25.6832 18.7424Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 9.92969,
    y: 10.5372,
    width: 10.8069,
    height: 8.54656,
    transform: "rotate(-15.0579 9.92969 10.5372)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 8.50043,
    y: 5.26256,
    width: 5.47827,
    height: 4.17705,
    transform: "rotate(-15.0579 8.50043 5.26256)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActInventory);
export default __webpack_public_path__ + "static/media/actInventory.cc86283379f87e361a4cbda98a8c5ead.svg";
export { ForwardRef as ReactComponent };